import {
  mdiAutoFix,
  mdiCommentTextMultipleOutline,
  mdiFeather,
  mdiFolderImage,
  mdiPail,
  mdiTooltipImageOutline
} from '@mdi/js'
import Icon from '@mdi/react'
import { PresetCard } from 'components/PresetCard'
import * as React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router'
import { openComposerContentDialog } from 'services/ui'
import { currentUserSelector } from 'services/users/selectors'
import styles from './QuickActions.pcss'

const css = require('styles/variables')

interface QuickAction {
  id: string
  title: string
  subtitle: string
  icon: React.ReactNode
  url: string
  overlay?: boolean
}

const ICON_SIZE = '34px'

const QUICK_ACTIONS: QuickAction[] = [
  {
    id: 'single',
    title: 'Create a single post',
    subtitle: 'Create a post for your socials',
    icon: <Icon path={mdiFeather} size={ICON_SIZE} />,
    url: '/composer',
    overlay: true
  },
  {
    id: 'multi',
    title: 'Create multiple posts',
    subtitle: 'Create posts in bulk',
    icon: <Icon path={mdiCommentTextMultipleOutline} size={ICON_SIZE} />,
    url: '/composer/multi',
    overlay: true
  },
  {
    id: 'ai',
    title: 'Create AI content',
    subtitle: 'Prompt AI to generate content',
    icon: <Icon path={mdiAutoFix} size={ICON_SIZE} />,
    url: '/composer',
    overlay: true
  },
  {
    id: 'buckets',
    title: 'Manage your buckets',
    subtitle: 'Organize your posts by category',
    icon: <Icon path={mdiPail} size={ICON_SIZE} />,
    url: '/posts/buckets'
  },
  {
    id: 'library',
    title: 'Browse your library',
    subtitle: 'View and manage your media',
    icon: <Icon path={mdiFolderImage} size={ICON_SIZE} />,
    url: '/content/library'
  },
  {
    id: 'curate',
    title: 'Curate from social media',
    subtitle: 'Find top performing social posts',
    icon: <Icon path={mdiTooltipImageOutline} size={ICON_SIZE} />,
    url: '/content/search/sources/facebook?q='
  }
]

export function QuickActions() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const user = useSelector(currentUserSelector)

  const handleClick = (action: QuickAction) => () => {
    if (action.id === 'ai') {
      dispatch(openComposerContentDialog({ tab: 'generate' }))
    } else if (action.overlay) {
      navigate(action.url, {
        state: { floating: true, modal: 'compose', opener: location.pathname, background: location }
      })
    } else {
      navigate(action.url)
    }
  }

  return (
    <div className={styles.container}>
      <h3 className={styles['title-main']}>
        {`Howdy ${user?.name || ''} 👋 ... Let’s get to work!`}
      </h3>
      <div className={styles.wrapper}>
        {QUICK_ACTIONS.map(action => (
          <PresetCard
            key={action.id}
            title={action.title}
            subtitle={action.subtitle}
            icon={action.icon}
            iconColor={css['--pp-green']}
            onClick={handleClick(action)}
            className={styles.card}
            data-testid={`quick-action-${action.id}`}
          />
        ))}
      </div>
    </div>
  )
}
